import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const useOverquotaSpecificTariffs = getFeature('use-overquota-tarriff');

type TariffList = {
    year?: string[];
    month: string[];
};

export const tariffOverquotaList: TariffList = getFeature('tariff-overquota-list') || {
    month: [
        'W256GB_1m_landing_segmentation_main',
        'W512GB_1m_landing_segmentation_main',
        'W1TB_1m_landing_segmentation_main',
        'W2TB_1m_landing_segmentation_main',
    ],
};
